import React, { useCallback } from "react";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import { useHistory } from "react-router-dom";

import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../components/CustomButtons/Button.js";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import { ReactComponent as SuccessCardIcon } from "../../assets/img/icon_add_a_card_success.svg"
import { ReactComponent as CancelCardIcon } from "../../assets/img/cancel_card.svg";
import { primaryIconColor } from "../../style.scss"
import { loginToApp } from "../../redux-services/actions/actions.js";


const useStyles = makeStyles(themeStyle);

export function LinkCardStatus(props) {
  const pageState = props?.appData?.pageState;
  const fromScreen = pageState.fromScreen;
  const history = useHistory();
  const classes = useStyles();
  const query = new URLSearchParams(window?.location?.search);
  const status = query.get('status');

  const backToHome = useCallback(() => {
    delete props.appData.pageState;
    const appData = {
      ...props?.appData,
      isRefresh: true
    }
    props.linkCardStatusHandler(appData);
    history.push({
      pathname: '/pages/dashboard',
    });
  }, [history, props])

  const returnScreenName = (screenCode) => {
    switch (screenCode) {
      case 'BUYAIRTIMEDATA':
        return 'Airtime Data';
      case 'BUYELECTRICITY':
        return 'Electricity';
      case 'AIRTIMEDATA':
        return 'Airtime Data';
      case 'COLLECTIONS':
        return 'Collections';
      case 'VAS':
        return 'Buy';
      case 'PAYBILL':
        return 'Pay Bill';
      case 'TOPUP':
        return 'Top-up';
      case 'MANAGE-CARDS':
        return 'My Cards';
      case 'QRSCAN':
        return 'Scan QR';
      default:
        return 'Home';
    }
  }

  const goToBack = useCallback(() => {
    if (fromScreen === 'AIRTIMEDATA' || fromScreen === 'BUYAIRTIMEDATA' || fromScreen === 'BUYELECTRICITY') {
      history.push({
        pathname: '/pages/vas-buy-airtime-data',
        state: { ...pageState }
      });
    } else if (fromScreen === 'COLLECTIONS') {
      history.push({
        pathname: '/pages/vas-buy-kganya-products',
        state: { ...pageState }
      });
    } else if (fromScreen === 'PAYBILL') {
      history.push({
        pathname: '/pages/vas-pay-bill',
        state: { ...pageState }
      });
    } else if (fromScreen === 'QRSCAN') {
      history.push({
        pathname: '/pages/pay-amount',
        state: { ...pageState }
      });
    } else if (fromScreen === 'TOPUP') {
      history.push({
        pathname: '/pages/topup',
        state: { ...pageState }
      });
    } else if (fromScreen === 'MANAGE-CARDS') {
      history.push({
        pathname: '/pages/manage-linked-cards',
        state: { ...pageState }
      });
    } else {
      backToHome();
    }
  }, [fromScreen, history, pageState, backToHome]);

  React.useEffect(() => {
    return () => {
      window.onpopstate = () => {
        backToHome();
      }
    };
  }, [backToHome])

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center', marginTop: '20px' }}>
              {status && status === 'CANCEL' ?
                <CancelCardIcon stroke={primaryIconColor} fill={primaryIconColor} />
                : <SuccessCardIcon stroke={primaryIconColor} fill={primaryIconColor} />}
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <h5 className={classes.textCenter + ' m-t-0 m-b-0'}>
                {status && status === 'CANCEL' ?
                  <b>Your card was failed to link.</b>
                  : <b>Your card is now securely linked and ready to use</b>}
              </h5>
            </GridItem>
            <GridItem xs={12} sm={12} md={12} style={{ marginTop: '40px' }}>
              <Button className={classes.buttonRadius} size="lg" block color="transparent" type="button" onClick={goToBack} >Back {fromScreen ? 'to ' + returnScreenName(fromScreen) : ''}</Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  )
}


const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

const mapDispatchToProps = dispatch => ({
  linkCardStatusHandler: data => dispatch(loginToApp(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(LinkCardStatus)